import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, switchMap } from 'rxjs';
import { Carousel } from 'primeng/carousel';
import { SpinnerFilledComponent } from '@web/shared/ui';
import { PublicBrandBannerDataSourceService } from '../../services/public-brand-banner-data-source.service';
import { PublicBrandBannerCollectionItem } from '../../models/public-brand-banner-collection-item';
import { PublicBrandBannerCarouselItemComponent } from '../../components/public-brand-banner-carousel-item/public-brand-banner-carousel-item.component';

@Component({
  selector: 'app-public-brand-banner-carousel',
  imports: [
    Carousel,
    CommonModule,
    PublicBrandBannerCarouselItemComponent,
    SpinnerFilledComponent,
  ],
  templateUrl: './public-brand-banner-carousel.component.html',
  styleUrl: './public-brand-banner-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBrandBannerCarouselComponent {
  private readonly bannerDataSource = inject(
    PublicBrandBannerDataSourceService,
  );

  public readonly slug = input.required<string>();

  protected readonly slug$ = toObservable(this.slug);
  protected readonly banners$ = this.bannersSource();

  protected isMoreThanOne(banners: PublicBrandBannerCollectionItem[]): boolean {
    return banners.length > 1;
  }

  private bannersSource(): Observable<PublicBrandBannerCollectionItem[]> {
    return this.slug$.pipe(
      switchMap((slug) =>
        this.bannerDataSource.fetchCollection({
          slug,
        }),
      ),
    );
  }
}
